import { dialog } from '@/plugins/dialog/index'
import InstanceBox from './index.vue';

/**
 * 选中的是整个券行（调用方只取 id），没有可选参数。
 *
 * 必须带自己的 key：这个选择器是在「礼物」弹窗**里面**打开的，
 * 而 dialog() 默认用 'default' 这个 key，撞上已经在打开的那个就直接
 * resolve([{ msg: '已唤起' }])、什么都不弹。
 * 换独立 key 后各建各的 app 实例和根节点，两个弹窗能叠着放。
 */
export default function () {
  return dialog({
    title: '选择优惠券',
    props: {
      width: '900px'
    },
    content() {
      return <InstanceBox></InstanceBox>
    }
  }, 'choose-coupon')
}
